import React, { useEffect, useState, useMemo } from 'react'
import './styles.scss'
import { products } from 'data/shop/products'
import { useParams } from 'react-router-dom'
import productData from 'services/getProducts'
import ProductCard from 'components/ProductCard'
import arrowRelatedDisable from 'assets/shop/arrow_related_disable.png'
import arrowRelated from 'assets/shop/arrow_related.png'
import arrowRelatedLeft from 'assets/shop/arrow_related_left.png'
import arrowRelatedDisableRight from 'assets/shop/arrow_related_disable_right.png'

const ProductRelated = () => {
  const { slug } = useParams()
  const product = productData.getProductBySlug(slug)
  const { categorySlug, colors } = product
  const [firstItem, setFirstItem] = useState(0)
  const [itemsToShow, setItemsToShow] = useState(0)

  useEffect(() => {
    function updateItemsToShow() {
      const windowWidth = window.innerWidth
      if (windowWidth >= 1440) {
        setItemsToShow(4)
      } else if (windowWidth >= 750) {
        setItemsToShow(2)
      } else {
        setItemsToShow(1)
      }
    }

    updateItemsToShow()
    window.addEventListener('resize', updateItemsToShow)

    return () => {
      window.removeEventListener('resize', updateItemsToShow)
    }
  }, [])

  const filteredProducts = useMemo(() => {
    return products.filter((item) => {
      return item.categorySlug === categorySlug && item.colors === colors && item.slug !== slug
    })
  }, [categorySlug, colors, slug])

  const handleNextClick = () => {
    if (firstItem + itemsToShow < filteredProducts.length) {
      setFirstItem(firstItem + 1)
    }
  }

  const handlePrevClick = () => {
    if (firstItem > 0) {
      setFirstItem(firstItem - 1)
    }
  }

  const visibleProducts = filteredProducts.slice(firstItem, firstItem + itemsToShow)

  return (
    <div className="product-related">
      <h2>PRODUCTS RELATED</h2>
      <hr />

      <div className="main-frame-card-related">
        <button onClick={handlePrevClick} disabled={firstItem === 0}>
          <img src={firstItem === 0 ? arrowRelatedDisable : arrowRelatedLeft} alt="" />
        </button>

        <div className="frame-card-related">
          {visibleProducts.map((item, index) => (
            <ProductCard
              key={index}
              img01={item.image01}
              name={item.title}
              price={Number(item.price)}
              slug={item.slug}
            />
          ))}
        </div>

        <button
          onClick={handleNextClick}
          disabled={firstItem + itemsToShow === filteredProducts.length}
        >
          <img
            src={
              firstItem + itemsToShow === filteredProducts.length ||
              filteredProducts.length < itemsToShow
                ? arrowRelatedDisableRight
                : arrowRelated
            }
            alt=""
          />
        </button>
      </div>
    </div>
  )
}

export default ProductRelated
